const AmoCRM = () => {
  return <span className="amocrm">amoCRM</span>
}

export default AmoCRM
